import React from 'react';
import { App } from '@mb/App';
import { createRoot } from 'react-dom/client';
import { CollectionsApp } from './CollectionsApp';

const container = document.getElementById('curated-collections-container');
const root = createRoot(container!);
root.render(
  <App>
    <CollectionsApp />
  </App>,
);
